import { Link } from "@tanstack/react-router";
import { Icon } from "@/components/ui/Icon";

export interface BreadcrumbItem {
  label: string;
  // Tanstack Router `to` value; omit for the current (last) crumb so it renders
  // as plain text rather than a link.
  to?: string;
  params?: Record<string, string>;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav
      aria-label="Breadcrumb"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        fontSize: 12,
        color: "var(--ink-3)",
      }}
    >
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        const sep = i > 0 ? <Icon name="chevRight" size={11} /> : null;
        if (isLast || !item.to) {
          return (
            <span
              key={`${item.label}-${i}`}
              style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
            >
              {sep}
              <span style={{ color: "var(--ink-1)", fontWeight: 500 }}>{item.label}</span>
            </span>
          );
        }
        const linkProps = item.params ? { to: item.to, params: item.params } : { to: item.to };
        return (
          <span
            key={`${item.label}-${i}`}
            style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
          >
            {sep}
            <Link
              {...(linkProps as { to: string; params?: Record<string, string> })}
              style={{
                color: "var(--ink-3)",
                textDecoration: "none",
                transition: "color .12s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "var(--ink-1)")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "var(--ink-3)")}
            >
              {item.label}
            </Link>
          </span>
        );
      })}
    </nav>
  );
}
